'use client';

import { getSupabaseClient } from '@popow/infra/lib/supabase/client';
import { useEffect } from 'react';
import { useAuth } from '@/shared/auth';
import { useNotificationStore } from './useNotificationStore';

/**
 * NotificationStoreInitializer initializes the notification store
 * - Subscribes to notification INSERT/UPDATE events via Realtime
 * - Maintains unread count
 * - Automatically updates UI when notifications change
 */
export function NotificationStoreInitializer() {
  const user = useAuth(s => s.user);
  const initialize = useNotificationStore(s => s.initialize);

  useEffect(() => {
    const supabase = getSupabaseClient();
    const cleanup = initialize(supabase, user?.id || null);
    return cleanup;
  }, [user?.id, initialize]);

  return null;
}
